module.exports = __webpack_public_path__ + "img/location-icon.82a920d0.svg";